// tracing.ts
import { defaultResource, resourceFromAttributes } from '@opentelemetry/resources';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';

// Get configuration from environment or use domain-based defaults
const getOtelConfig = () => {
  // Use your domain instead of IP:port
  const baseUrl = process.env.REACT_APP_BASE_URL || "https://rhipcicd.moh.gov.rw";
  const otelEndpoint = process.env.REACT_APP_OTEL_ENDPOINT || `${baseUrl}/api/traces`;
  const serviceName = process.env.REACT_APP_SERVICE_NAME || 'RHIP-FRONTEND';
  const serviceVersion = process.env.REACT_APP_SERVICE_VERSION || '1.0.0';
  const environment = process.env.REACT_APP_ENVIRONMENT || 'staging';

 console.log('OpenTelemetry Configuration:', {
    baseUrl,
    endpoint: otelEndpoint,
    serviceName,
    serviceVersion,
    environment
  });

  return {
    endpoint: otelEndpoint,
    serviceName,
    serviceVersion,
    environment
  };
};

const config = getOtelConfig();

const resource = defaultResource().merge(
    resourceFromAttributes({
        'service.name': config.serviceName,
        'service.version': config.serviceVersion,
        'deployment.environment': config.environment,
        'service.namespace': 'frontend',
        'deployment.type': 'docker',
        'telemetry.proxy': 'nginx',
    }),
);

// Create exporter pointing to your domain
const exporter = new OTLPTraceExporter({
    url: config.endpoint,
    headers: {
        'Content-Type': 'application/json',
    },
});

const processor = new BatchSpanProcessor(exporter, {
    maxQueueSize: 100,
    scheduledDelayMillis: 500,
    exportTimeoutMillis: 30000,
    maxExportBatchSize: 10,
});

const provider = new WebTracerProvider({
    resource: resource,
    spanProcessors: [processor],
});

provider.register({
    contextManager: new ZoneContextManager(),
});

registerInstrumentations({
    instrumentations: [
        getWebAutoInstrumentations({
            // Configure fetch instrumentation
            '@opentelemetry/instrumentation-fetch': {
                propagateTraceHeaderCorsUrls: [
                    new RegExp(window.location.origin),
                    /.+/g, // All external URLs
                ],
            },
            // Configure XMLHttpRequest instrumentation  
            '@opentelemetry/instrumentation-xml-http-request': {
                propagateTraceHeaderCorsUrls: [
                    new RegExp(window.location.origin),
                    /.+/g, // All external URLs
                ],
            },
            // Enable user interaction tracking
            '@opentelemetry/instrumentation-user-interaction': {
                enabled: true,
                eventNames: ['click', 'submit'],
            },
            // Enable document load performance tracking
            '@opentelemetry/instrumentation-document-load': {
                enabled: true,
            },
        }),
    ],
});

// Export tracer for manual instrumentation
export const tracer = provider.getTracer(config.serviceName, config.serviceVersion);

console.log(`OpenTelemetry initialized for ${config.serviceName} - sending to ${config.endpoint}`);
